import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { AppProvider, Frame, Toast } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import axios from 'axios';

import OrdersPage from './pages/OrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import SettingsPage from './pages/SettingsPage';
import InstallPage from './pages/InstallPage';
import CallbackPage from './pages/CallbackPage';
import AutomationPage from './pages/AutomationPage';
import BillingPage from './pages/BillingPage';
import ShipmentsPage from './pages/ShipmentsPage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AppContext = React.createContext();

function AppContent() {
  const [shop, setShop] = useState(null);
  const [storeData, setStoreData] = useState(null);
  const [toastActive, setToastActive] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastError, setToastError] = useState(false);
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const shopParam = searchParams.get('shop') || searchParams.get('host');
    
    if (shopParam) {
      const shopName = shopParam.includes('.myshopify.com') ? shopParam : null;
      if (shopName) {
        setShop(shopName);
        localStorage.setItem('shop', shopName);
      } else {
        const decodedHost = searchParams.get('host');
        if (decodedHost) {
          try {
            const hostDecoded = atob(decodedHost).split('/')[0];
            if (hostDecoded) {
              setShop(hostDecoded);
              localStorage.setItem('shop', hostDecoded);
            }
          } catch (e) {
            console.error('Error decoding host:', e);
          }
        }
      }
    } else {
      const storedShop = localStorage.getItem('shop');
      if (storedShop) {
        setShop(storedShop);
      }
    }
  }, [searchParams]);

  const showToast = (message, isError = false) => {
    setToastMessage(message);
    setToastError(isError);
    setToastActive(true);
  };

  const toggleToast = () => setToastActive(false);

  const contextValue = {
    shop,
    setShop,
    storeData,
    setStoreData,
    showToast,
    API
  };

  const toastMarkup = toastActive ? (
    <Toast
      content={toastMessage}
      onDismiss={toggleToast}
      error={toastError}
    />
  ) : null;

  return (
    <AppContext.Provider value={contextValue}>
      <Frame>
        {toastMarkup}
        <Routes>
          <Route path="/" element={<OrdersPage />} />
          <Route path="/install" element={<InstallPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/orders/:orderId" element={<OrderDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/automation" element={<AutomationPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/shipments" element={<ShipmentsPage />} />
        </Routes>
      </Frame>
    </AppContext.Provider>
  );
}

function App() {
  return (
    <AppProvider i18n={{}}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;